import Style from "./BillsCopiesTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { IoMdCheckmarkCircle } from "react-icons/io";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function BillsCopies() {

  const [popupOpen, setPopupOpen] = useState(false);
  const [requestToUpdate, setRequestToUpdate] = useState({} as any);
  const [updatingToSended, setUpdatingToSended] = useState(false);

  const [loadingCopiesRequest, setLoadingCopiesRequest] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [copiesRequest, setCopiesRequest] = useState([] as any);

  useEffect(() => {
    LoadCopiesRequest();
  }, []);


  function ClosePopupDeletingMaterial() {
    setPopupOpen(false);
  }

  async function UpdateToSend() {

    setUpdatingToSended(true);
    try {
      await api.put(`bills/finishCopyRequest`, { requestId: requestToUpdate.requestId });
      await LoadCopiesRequest();
      setUpdatingToSended(false);
      setPopupOpen(false);
      setRequestToUpdate(false);
    }
    catch (error) {
      console.error(error);
      setUpdatingToSended(false);
      setPopupOpen(false);
      setRequestToUpdate(false);
      setErrorMessage("Erro marcando pedido de segunda via como realizado");
    }
  }

  async function LoadCopiesRequest() {
    setLoadingCopiesRequest(true);
    try {
      const result = await api.get(`/bills/copiesRequests`);
      setLoadingCopiesRequest(false);
      if (!result.data.success) {
        setErrorMessage(`Não foi possível carregar lista de pedidos de segunda via, ${result.data}`);
      }
      else {
        setErrorMessage("");
        setCopiesRequest(result.data.requests);
      }
    }
    catch (error) {
      setLoadingCopiesRequest(false);
      setErrorMessage(`Não foi possível carregar lista de pedidos de segunda via, ${error}`);
      console.error(error);
    }
  }

  return (
    <Style>
      <PageTitle title="Pedidos de Segunda-Via" />
      <TwoButtonsModal
        show={popupOpen}
        onHide={ClosePopupDeletingMaterial}
        loading={updatingToSended}
        title="Marcando como enviado!"
        body={`Tem certeza que quer marcar pedido como enviado?`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingMaterial}
        secondaryDisabled={updatingToSended}
        primaryText="Marcar"
        primaryOnClick={UpdateToSend}
        primaryDisabled={updatingToSended}
      />

      {errorMessage !== "" && <h1 className="alert"> {errorMessage}</h1>}
      <Spinner spinning={loadingCopiesRequest} />
      <section className="table-title">
        <h1>Pedidos de 2ª via</h1>
      </section>
      <table className="table table-striped table-bordered table-hover">
        <thead >
          <tr>
            <th>Usuário Requisitando</th>
            <th>Documento</th>
            <th>Código do Documento</th>
            <th>ID da Fatura</th>
            <th>Parcela</th>
            <th>Finalizar</th>
          </tr>
        </thead>
        <tbody>
          {copiesRequest?.length > 0 && copiesRequest.map(request => {
            return (
              <tr key={` ${request.billRequesting} + ${request.installmentRequesting}`}>
                <td spellCheck={false}>{request.name}</td>
                <td>{request.documentId}</td>
                <td>{request.documentCode}</td>
                <td>{request.billRequesting}</td>
                <td>{request.installmentRequesting + "ª"}</td>
                <td >
                  <div className="action" onClick={() => { setRequestToUpdate(request); setPopupOpen(true) }}>
                    <IoMdCheckmarkCircle className="icon" /></div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}